import React from 'react';
import { Tr } from '@chakra-ui/react';

type TableRowProps = React.PropsWithChildren<React.TableHTMLAttributes<HTMLTableRowElement>>;

// Chakra's Tr type can trigger TS2590 on newer TS versions; this keeps the styling
// while presenting a simpler signature to the type checker.
const TableRow = Tr as unknown as React.FC<TableRowProps>;

export default TableRow;
